import React from 'react';
import './LLMOutput.css';

const SECTION_CONFIG = [
  { key: 'diagnostics', label: 'Diagnostik', icon: 'D' },
  { key: 'treatment', label: 'Behandlung', icon: 'B' },
  { key: 'medications', label: 'Medikamente', icon: 'M' },
];

function BookmarkIcon({ active }) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  );
}

function CheckmarkIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function DiagnosisCard({ diagnosis, index, onBookmark, isBookmarked, selectionState, onSelect }) {
  return (
    <div className={`diagnosis-card${selectionState ? ` selected-${selectionState}` : ''}`}>
      <div className="diagnosis-header">
        <span className="diagnosis-number">{index + 1}</span>
        <div className="diagnosis-header-content">
          <h3 className="diagnosis-name">{diagnosis.name}</h3>
          <p className="diagnosis-reason">{diagnosis.reason}</p>
        </div>
        {onSelect && (
          <button
            className={`diagnosis-check-btn${selectionState ? ` ${selectionState}` : ''}`}
            onClick={(e) => { e.stopPropagation(); onSelect(diagnosis.name); }}
            title={selectionState === 'primary' ? 'Hauptdiagnose (abwählen)' : selectionState === 'secondary' ? 'Nebendiagnose (abwählen)' : 'Als Diagnose auswählen'}
          >
            <CheckmarkIcon />
          </button>
        )}
      </div>

      <div className="diagnosis-sections">
        {SECTION_CONFIG.map(({ key, label, icon }) => {
          const items = diagnosis[key];
          if (!items || items.length === 0) return null;
          return (
            <div key={key} className={`diagnosis-section section-${key}`}>
              <div className="section-header">
                <span className="section-icon">{icon}</span>
                <h4>{label}</h4>
              </div>
              <ul>
                {items.map((item, i) => {
                  const bookmarked = isBookmarked && isBookmarked(diagnosis.name, label, item);
                  return (
                    <li key={i} className={bookmarked ? 'bookmarked' : ''}>
                      <span className="item-text">{item}</span>
                      {onBookmark && (
                        <button
                          className={`bookmark-btn${bookmarked ? ' active' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            onBookmark({ diagnosisName: diagnosis.name, sectionLabel: label, itemText: item });
                          }}
                          title={bookmarked ? 'Bookmark entfernen' : 'Zum Lernen merken'}
                        >
                          <BookmarkIcon active={bookmarked} />
                        </button>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function LLMOutput({ result, isProcessing, isUpdating, onBookmark, isBookmarked, selectedDiagnoses, onDiagnosisSelect }) {
  const getSelectionState = (name) => {
    if (!selectedDiagnoses || selectedDiagnoses.length === 0) return null;
    const idx = selectedDiagnoses.indexOf(name);
    if (idx === -1) return null;
    return idx === 0 ? 'primary' : 'secondary';
  };

  return (
    <div className="llm-output">
      {isUpdating && <div className="updating-bar analysis" />}
      <h2 className="llm-output-title">KI-Analyse: Differentialdiagnosen</h2>
      {isProcessing ? (
        <div className="loading">KI verarbeitet...</div>
      ) : result && result.length > 0 ? (
        <div className="diagnoses-grid">
          {result.map((diagnosis, index) => (
            <DiagnosisCard
              key={index}
              diagnosis={diagnosis}
              index={index}
              onBookmark={onBookmark}
              isBookmarked={isBookmarked}
              selectionState={getSelectionState(diagnosis.name)}
              onSelect={onDiagnosisSelect}
            />
          ))}
        </div>
      ) : (
        <div style={{ color: '#9ca3af', fontSize: '14px' }}>
          Die Analyse wird nach der Transkription automatisch durchgeführt.
        </div>
      )}
    </div>
  );
}

export default LLMOutput;
